import { useSelector, shallowEqual } from 'react-redux';
import { calculateIsFullScreen } from 'actions/utils';

const useIsFullScreen = () => useSelector(({ scene: { config: { layoutId, layouts, layoutGutterType } } }) => calculateIsFullScreen({ layoutId, layouts, layoutGutterType }), shallowEqual);

export default useIsFullScreen;
